import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { CbicContentMstRoutingModule } from './route/cbic-content-mst-routing.module';
import { ViewContentComponent } from './view-content/view-content.component';
import { TableComponent } from 'app/entities/cbic-content-mst/view-content/table/table.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { AccordianComponent } from './view-content/accordian/accordian.component';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { TilesComponent } from './view-content/tiles/tiles.component';
import { FilterYearPipe } from './view-content/table/filterYear.pipe';

@NgModule({
  imports: [
    NgbModalModule,
    SharedModule, CbicContentMstRoutingModule, NgxPaginationModule,],
  declarations: [
    ViewContentComponent,TableComponent, AccordianComponent, TilesComponent,FilterYearPipe
  ],
  exports:[ViewContentComponent],
  entryComponents: [ViewContentComponent],
})
export class CbicContentMstModule {}
